/**
 * /* eslint-disable no-unused-vars
 *
 * @format
 */

/**
 * /* eslint-disable no-unused-vars
 *
 * @format
 */

/** @format */

import Page from "../../components/Page";
import {
  Avatar,
  Button,
  Card,
  CircularProgress,
  Container,
  // Divider,
  Grid,
  IconButton,
  Input,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Iconify from "../../components/Iconify";
// import {styled} from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import React, { useState, useEffect } from "react";
import { LoadingButton } from "@mui/lab";
// import Constants from "../../configs/Constants";
import { useNavigate, useParams } from "react-router-dom";
import PhoneNumber from "../../dao/PhoneNumber";
import swal from "../../reusables/CustomSwal";
// import * as Yup from 'yup'
// import TextFormatter from "../../utils/TextFormatter";
import { useSelector } from "react-redux";

import * as yup from "yup";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
// import { result } from "lodash";

const yupSchemeProfile = yup.object().shape({
  address: yup.string().max(256),
  description: yup.string().max(512),
  vertical: yup.string(),
  email: yup
    .string()
    .email("Wrong email format")
    .min(3, "Minimum 3 symbols")
    .max(128, "Maximum 128 symbols"),
  websites: yup.array(
    yup
      .string()
      .min(0)
      .matches(
        /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
        "Enter correct url!"
      )
      .required()
  ),
  profile_picture_url: yup
    .mixed()
    .test("fileSize", "The Files is to large", (value) => {
      return (
        (value && value.size <= 5242880) ||
        typeof value === "string" ||
        value !== null
      );
    })
    .test("type", "we only support jpeg, png, and pdf", (value) => {
      return (
        (value &&
          (value.type === "image/jpeg" || value.type === "image/png")) ||
        typeof value === "string" ||
        value !== null
      );
    }),
});

const yupWebhook = yup.object().shape({
  custom_url: yup
    .string()
    .min(0)
    .matches(
      /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      "Enter correct url!"
    )
    .required(),
});

export default function NumberForm() {
  let role = useSelector(({ auth }) => auth.auth.role);
  const { id } = useParams();
  const navigate = useNavigate();

  const [numPrefix, setNumPrefix] = useState("+62");
  // const [showPassword, setShowPassword] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState({});

  // const [profileData, setProfileData] = useState(null);

  // const [dockerType, setDockerType] = useState("ON_PREMISE");

  const [partnerToken, setPartnerToken] = useState("");
  const [dataIsFound, setDataIsFound] = useState(true);
  // const [dataExistingInLocalDB, setDataExistingInLocalDB] = useState(false);
  const [dataIsFetched, setDataIsFetched] = useState(false);
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingProfile, setIsSubmittingProfile] = useState(false);
  const [isUploadPicture, setIsUploadPicture] = useState(false);
  // const [type, setType] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [dockerStatus, setDockerStatus] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [formWebHook, setFormWeb] = useState({
    custom_url: "",
  });
  const [form, setForm] = useState({
    about: "",
    address: "",
    description: "",
    vertical: "",
    email: "",
    websites: [],
    profile_picture_url: "",
  });

  // const [isTestingConnection, setIsTestingConnection] = useState(false)
  // const [isTestingConnection] = useState(false);

  const isAdmin = role === "SUPER_ADMIN" || role === "ADMIN";

  const verticalCategory = [
    { label: "Automotive", value: "Automotive" },
    { label: "Beauty, Spa and salon", value: "Beauty, Spa and salon" },
    { label: "Clothing and Apparel", value: "Clothing and Apparel" },
    { label: "Education", value: "Education" },
    { label: "Entertainment", value: "Entertainment" },
    {
      label: "Event Planning and Service",
      value: "Event Planning and Service",
    },
    { label: "Finance and Banking", value: "Finance and Banking" },
    { label: "Food and Grocery", value: "Food and Grocery" },
    { label: "Public Service", value: "Public Service" },
    { label: "Hotel and Lodging", value: "Hotel and Lodging" },
    { label: "Medical and Health", value: "Medical and Health" },
    { label: "Non-profit", value: "Non-profit" },
    { label: "Professional Service", value: "Professional Service" },
    { label: "Shopping and Retail", value: "Shopping and Retail" },
    { label: "Travel and Transportation", value: "Travel and Transportation" },
    { label: "Restaurant", value: "Restaurant" },
    { label: "Other", value: "OTHER" },
  ];

  const onLoad = async () => {
    setDataIsFetched(false);
    // here
    // setDataIsFound(false);
    // setDataExistingInLocalDB(false);

    // let phoneNumberById = null

    try {
      let result1 = await PhoneNumber.getByID(id);
      // console.log(result1);

      const phoneNumRaw = result1.display_phone_number;

      const phoneNum = result1.display_phone_number.replace(/\D/g, "");
      let prefix = result1.display_phone_number.substring(
        0,
        result1.display_phone_number.indexOf(" ")
      );
      result1.display_phone_number = result1.display_phone_number.substring(
        result1.display_phone_number.indexOf(" ") + 1
      );
      setNumPrefix(prefix);
      let fetchNumId = phoneNum.replace("-");

      // console.log("====test", fetchNumId);
      try {
        // let onPrem = await PhoneNumber.getOnPrem(fetchNumId);
        let key = await PhoneNumber.getToken({ number: fetchNumId });
        await setPartnerToken(key?.token);
        // console.log(key, "key");

        let body = await {
          partner_token: key?.token,
          account_id: fetchNumId,
          docker_type: "cloud",
        };
        // console.log("body", body);
        let detailData = await PhoneNumber.getDetailByIdWithWebhook(body);

        let data = {
          about: detailData?.data[0]?.about ? detailData?.data[0]?.about : "",
          address: detailData?.data[0]?.address
            ? detailData?.data[0]?.address
            : "",
          description: detailData?.data[0]?.description
            ? detailData?.data[0]?.description
            : "",
          vertical: detailData?.data[0]?.vertical
            ? detailData?.data[0]?.vertical
            : "",
          email: detailData?.data[0]?.email ? detailData?.data[0]?.email : "",
          websites: detailData?.data[0]?.websites
            ? detailData?.data[0]?.websites
            : [],
          profile_picture_url: detailData?.data[0]?.profile_picture_url
            ? detailData?.data[0]?.profile_picture_url
            : "",
        };

        let webhookSetting = await PhoneNumber.getWebhookSettingByPhoneNumber(
          fetchNumId
        );
        setFormWeb({ custom_url: webhookSetting[0].custom_url });

        setForm({ ...data });
      } catch (err) {
        alert(err);
      }

      let final = {
        ...result1,
        url: "",
        username: "",
        password: "",
        prefix: prefix,
        phone_number: phoneNum,
        facebook_id: result1.id,
        phone_number_raw: phoneNumRaw,
      };

      // console.log("RES1", result1);
      setPhoneNumber({ ...final });

      /**Ini Untuk ambil data dari dataabase local**/
      let result2 = await PhoneNumber.waGetByID(phoneNum);

      // setDataExistingInLocalDB(true);
      setPhoneNumber({
        ...final,
        ...result2,
      });
      try {
        // let result3 = await PhoneNumber.getBusinessProfile(phoneNum);

        // console.log(result4);

        final = {
          ...final,
          ...result2,
          // ...result3,
          // ...result4,
        };

        setPhoneNumber(final);
        setDataIsFound(true);

        // if (result3.business && result3.business.profile) {
        //   console.log("FBP", result3.business.profile);
        //   // setProfileData(result3.business.profile);
        // }

        // getDockerHealth();
        // setDockerHealthOk(true);
      } catch (e) {}
    } catch (err) {
      if (err.code === "WHATSAPP NUMBER WITH PHONE NUMBER_NOT_FOUND") {
        if (!isAdmin) {
          await swal.fire({
            title: "Error",
            text: "This number is not yet configured. Please contact admin for more detail.",
            icon: "error",
          });
        }

        // here
        // setDataIsFound(false);
        setDataIsFetched(true);
      } else {
        await swal.fire({
          title: "Error",
          text: err,
          icon: "error",
        });
      }
    }

    setDataIsFetched(true);
  };

  const onKeyDown = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };

  useEffect(() => {
    onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmitProfile = async (values) => {
    setIsSubmittingProfile(true);

    try {
      let body = {
        ...values,
        partner_token: partnerToken,
      };
      // console.log("body here", body);

      await PhoneNumber.updateBusinessProfile(body);

      await swal.fire({
        title: "Success",
        text: "Profile has been saved.",
        icon: "success",
      });

      await onLoad();
    } catch (e) {
      console.log(e);
    }

    setIsSubmittingProfile(false);
  };

  const onSubmitWebhook = async (values) => {
    setIsSubmittingProfile(true);

    try {
      const phoneNum = phoneNumber.display_phone_number.replace(/\D/g, "");
      let fetchNumId = phoneNum.replace("-");
      let body = {
        ...values,
        partner_token: partnerToken,
        phoneNumber: `62${fetchNumId}`,
      };
      await PhoneNumber.postWebhookSetting(body);

      await swal.fire({
        title: "Success",
        text: "Webhook has been saved.",
        icon: "success",
      });

      await onLoad();
    } catch (e) {
      console.log(e);
    }

    setIsSubmittingProfile(false);
  };

  const handlePictureProfile = async (setFieldValue, name, e) => {
    try {
      await setIsUploadPicture(true);
      const file = e.target.files[0];
      let formData = new FormData();
      formData.append("folder", "wa_panel");
      formData.append("directory", "wa_panel");
      formData.append("public", true);
      formData.append("files", file);
      let url = await PhoneNumber.postImage(formData);
      await setFieldValue(name, url.data[0].url);

      await setIsUploadPicture(false);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Page title="Manage WhatsApp Number">
      <Container>
        <Stack spacing={2} direction="row" sx={{ mb: 4 }}>
          <IconButton
            sx={{ p: 0, height: "100%", backgroundColor: "white" }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="eva:arrow-ios-back-fill" width={22} height={22} />
          </IconButton>
          <Typography variant="h4">Manage WhatsApp Number</Typography>
        </Stack>
        {dataIsFetched ? (
          <Grid container spacing={2}>
            <Grid
              item
              // md={dataIsFound ? 8 : 12}
              xs={12}
            >
              {/* <Card sx={{ p: 4 }} style={{ marginBottom: 10 }}>
                <Stack spacing={1}>
                  <Typography variant="p" sx={{ color: "gray" }}>
                    Profile Picture
                  </Typography>
                  <Stack direction="row" spacing={3}>
                    <Avatar
                      alt="profile-picture"
                      src={form.profile_picture_url}
                      sx={{ width: 100, height: 100 }}
                    />
                    <Stack spacing={2} justifyContent="flex-end">
                      <Typography
                        variant="p"
                        sx={{ color: "gray", fontSize: "0.8em" }}
                      >
                        Max. 1 MB in JPG, GIF, PNG, or BMP formats.
                        <br />
                        Recommended size 640 x 640 px
                      </Typography>
                      <Stack direction="row" spacing={3}>
                        <label htmlFor="icon-button-file">
                          <Input
                            // onChange={(e) => handlePictureProfile(e)}
                            accept="image/*"
                            id="icon-button-file"
                            type="file"
                            sx={{ display: "none" }}
                          />
                          <LoadingButton
                            variant="contained"
                            component="span"
                            loading={isUploadPicture}
                          >
                            <Iconify
                              icon="mdi:upload"
                              width={22}
                              height={22}
                              sx={{ marginRight: 1 }}
                            />
                            Upload
                          </LoadingButton>
                        </label>
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </Card> */}

              <Card sx={{ p: 4 }} style={{ marginBottom: 10 }}>
                <Formik
                  enableReinitialize
                  validationSchema={yupSchemeProfile}
                  initialValues={{ ...form }}
                  onSubmit={(values) => {
                    onSubmitProfile(values);
                  }}
                >
                  {(props) => {
                    const {
                      values,
                      errors,
                      setFieldValue,
                      handleChange,
                      touched,
                    } = props;
                    return (
                      <div>
                        <Form onKeyDown={onKeyDown}>
                          <Stack spacing={3}>
                            <Stack spacing={1}>
                              <Typography variant="p" sx={{ color: "gray" }}>
                                Profile Picture
                              </Typography>
                              <Stack direction="row" spacing={3}>
                                <Avatar
                                  alt="profile-picture"
                                  src={values.profile_picture_url}
                                  sx={{ width: 100, height: 100 }}
                                />
                                <Stack spacing={2} justifyContent="flex-end">
                                  <Typography
                                    variant="p"
                                    sx={{ color: "gray", fontSize: "0.8em" }}
                                  >
                                    Max. 1 MB in JPG, GIF, PNG, or BMP formats.
                                    <br />
                                    Recommended size 640 x 640 px
                                  </Typography>
                                  <Stack direction="row" spacing={3}>
                                    <label htmlFor="icon-button-file">
                                      <Input
                                        onChange={(e) =>
                                          handlePictureProfile(
                                            setFieldValue,
                                            "profile_picture_url",
                                            e
                                          )
                                        }
                                        accept="image/*"
                                        id="icon-button-file"
                                        type="file"
                                        sx={{ display: "none" }}
                                      />
                                      <LoadingButton
                                        variant="contained"
                                        component="span"
                                        loading={isUploadPicture}
                                      >
                                        <Iconify
                                          icon="mdi:upload"
                                          width={22}
                                          height={22}
                                          sx={{ marginRight: 1 }}
                                        />
                                        Upload
                                      </LoadingButton>
                                    </label>
                                  </Stack>
                                </Stack>
                              </Stack>
                            </Stack>
                            <Stack spacing={1}>
                              <Typography variant="p" sx={{ color: "gray" }}>
                                Name Whatsapp
                              </Typography>
                              <TextField
                                sx={{
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                fullWidth
                                disabled
                                value={phoneNumber.verified_name}
                                autoComplete="off"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Stack>
                            <Stack spacing={1}>
                              <Typography variant="p" sx={{ color: "gray" }}>
                                Whatsapp Number
                              </Typography>
                              <Stack spacing={1} direction="row">
                                <FormControl sx={{ width: "18%" }}>
                                  <Select
                                    sx={{
                                      "& legend": { display: "none" },
                                      "& fieldset": { top: 0 },
                                    }}
                                    disabled
                                    value={numPrefix}
                                    onChange={(e) =>
                                      setNumPrefix(e.target.value)
                                    }
                                  >
                                    <MenuItem value={"+61"}>+61</MenuItem>
                                    <MenuItem value={"+62"}>+62</MenuItem>
                                    <MenuItem value={"+63"}>+63</MenuItem>
                                  </Select>
                                </FormControl>
                                <TextField
                                  sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                  fullWidth
                                  disabled
                                  value={phoneNumber.display_phone_number}
                                  autoComplete="off"
                                  InputLabelProps={{ shrink: true }}
                                />
                              </Stack>
                            </Stack>
                            <Stack spacing={1}>
                              <Typography variant="p" sx={{ color: "gray" }}>
                                Status Whatsapp Number
                              </Typography>
                              <FormControl>
                                <Select
                                  sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                  // disabled
                                  // value={numPrefix}
                                  // onChange={(e) => setNumPrefix(e.target.value)}
                                >
                                  <MenuItem value={"BUSINESS_ACCOUNT"}>
                                    Business Account
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Stack>
                            <Stack spacing={1}>
                              <Typography variant="p" sx={{ color: "gray" }}>
                                Vertical
                              </Typography>
                              <FormControl>
                                <Select
                                  sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                  value={values.vertical}
                                  onChange={(e) =>
                                    setFieldValue("vertical", e.target.value)
                                  }
                                  error={Boolean(
                                    touched.vertical && errors.vertical
                                  )}
                                  helperText={
                                    touched.vertical && errors.vertical
                                  }
                                >
                                  {verticalCategory.map((item) => {
                                    return (
                                      <MenuItem value={item.value}>
                                        {item.label}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </Stack>

                            <Stack spacing={1}>
                              <Typography variant="p" sx={{ color: "gray" }}>
                                Quality
                              </Typography>
                              <TextField
                                sx={{
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                fullWidth
                                disabled
                                value={phoneNumber.quality_rating}
                                autoComplete="off"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Stack>

                            <Stack spacing={1}>
                              <Typography variant="p" sx={{ color: "gray" }}>
                                Profile Description
                              </Typography>
                              <TextField
                                sx={{
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                fullWidth
                                multiline
                                rows={4}
                                name={"description"}
                                value={values.description}
                                placeholder="Description"
                                autoComplete="off"
                                InputLabelProps={{ shrink: true }}
                                onChange={handleChange}
                                error={Boolean(
                                  touched.description && errors.description
                                )}
                                helperText={
                                  touched.description && errors.description
                                }
                              />
                            </Stack>
                            <Stack spacing={1}>
                              <Typography variant="p" sx={{ color: "gray" }}>
                                Email
                              </Typography>
                              <TextField
                                sx={{
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                fullWidth
                                name={"email"}
                                value={values.email}
                                placeholder="Company Email"
                                autoComplete="off"
                                InputLabelProps={{ shrink: true }}
                                onChange={handleChange}
                                error={Boolean(touched.email && errors.email)}
                                helperText={touched.email && errors.email}
                              />
                            </Stack>
                            <Stack spacing={1}>
                              <Typography variant="p" sx={{ color: "gray" }}>
                                Address
                              </Typography>
                              <TextField
                                sx={{
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                fullWidth
                                multiline
                                rows={4}
                                name={"address"}
                                value={values.address}
                                onChange={handleChange}
                                placeholder="Company Address"
                                autoComplete="off"
                                InputLabelProps={{ shrink: true }}
                                error={Boolean(
                                  touched.address && errors.address
                                )}
                                helperText={touched.address && errors.address}
                              />
                            </Stack>
                            <Stack>
                              <FieldArray
                                name="websites"
                                render={(arrayHelpers) => (
                                  <div>
                                    <Stack
                                      direction={"row"}
                                      justifyContent="space-between"
                                      alignItems="center"
                                    >
                                      <Typography
                                        variant="p"
                                        sx={{ color: "gray" }}
                                      >
                                        Websites
                                      </Typography>

                                      <Button
                                        variant="contained"
                                        type="button"
                                        sx={{ backgroundColor: "gray" }}
                                        onClick={() => arrayHelpers.push("")}
                                      >
                                        ADD MORE
                                      </Button>
                                    </Stack>
                                    {values.websites.map((website, index) => {
                                      return (
                                        <div key={index}>
                                          <Stack
                                            mt={2}
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="center"
                                          >
                                            <Field name={`websites[${index}]`}>
                                              {({ field }) => (
                                                <TextField
                                                  sx={{
                                                    width: "90%",
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": { top: 0 },
                                                  }}
                                                  type="text"
                                                  placeholder="Input Website"
                                                  {...field}
                                                />
                                              )}
                                            </Field>
                                            <Button
                                              variant="contained"
                                              ms={5}
                                              sx={{ backgroundColor: "red" }}
                                              type="button"
                                              onClick={() =>
                                                arrayHelpers.remove(index)
                                              }
                                            >
                                              x
                                            </Button>
                                          </Stack>
                                          <Typography
                                            variant="p"
                                            sx={{ color: "red" }}
                                          >
                                            <ErrorMessage
                                              name={`websites[${index}]`}
                                            />
                                          </Typography>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              />
                            </Stack>
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "flex-end",
                              }}
                            >
                              <LoadingButton
                                size="large"
                                type="submit"
                                style={{
                                  marginTop: 30,
                                }}
                                variant="contained"
                                loading={isSubmittingProfile}
                              >
                                <Iconify
                                  icon="eva:save-outline"
                                  width={22}
                                  height={22}
                                  sx={{ marginRight: 1 }}
                                />
                                Save
                              </LoadingButton>
                            </div>
                          </Stack>
                        </Form>
                      </div>
                    );
                  }}
                </Formik>
              </Card>

              <Card sx={{ p: 4 }} style={{ marginBottom: 10 }}>
                <Formik
                  validationSchema={yupWebhook}
                  enableReinitialize
                  initialValues={formWebHook}
                  onSubmit={(values) => {
                    // console.log(values);
                    onSubmitWebhook(values);
                  }}
                >
                  {(props) => {
                    const { values, errors, handleChange, touched } = props;
                    // console.log(errors);
                    return (
                      <div>
                        <Form onKeyDown={onKeyDown}>
                          <Stack spacing={3}>
                            <Stack spacing={1}>
                              <Typography variant="p" sx={{ color: "gray" }}>
                                Webhook
                              </Typography>
                              <TextField
                                sx={{
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                fullWidth
                                name={"custom_url"}
                                value={values.custom_url}
                                placeholder="Input your url custom hook"
                                autoComplete="off"
                                InputLabelProps={{ shrink: true }}
                                onChange={handleChange}
                                error={Boolean(
                                  touched.custom_url && errors.custom_url
                                )}
                                helperText={
                                  touched.custom_url && errors.custom_url
                                }
                              />
                            </Stack>

                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "flex-end",
                              }}
                            >
                              <LoadingButton
                                size="large"
                                type="submit"
                                style={{
                                  marginTop: 30,
                                }}
                                variant="contained"
                                loading={isSubmittingProfile}
                              >
                                <Iconify
                                  icon="eva:save-outline"
                                  width={22}
                                  height={22}
                                  sx={{ marginRight: 1 }}
                                />
                                Save
                              </LoadingButton>
                            </div>
                          </Stack>
                        </Form>
                      </div>
                    );
                  }}
                </Formik>
              </Card>
              {/* {isAdmin && (
                <Card sx={{ p: 4 }}>
                  {dockerHealthOk ? (
                    <Stack spacing={3}>
                      <Stack spacing={1}>
                        <Typography variant="p" sx={{ color: "gray" }}>
                          Docker Type
                        </Typography>
                        <Select
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          value={dockerType}
                          onChange={(e) => setDockerType(e.target.value)}
                        >
                          <MenuItem value={"ON_PREMISE"}>On Premise</MenuItem>
                          <MenuItem value={"CLOUD"}>Cloud</MenuItem>
                        </Select>
                      </Stack>
                      <Stack spacing={1}>
                        <Typography variant="p" sx={{ color: "gray" }}>
                          Webhook URL
                        </Typography>
                        <TextField
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          fullWidth
                          type="url"
                          value={phoneNumber.url}
                          autoComplete="off"
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) =>
                            setPhoneNumber({
                              ...phoneNumber,
                              url: e.target.value,
                            })
                          }
                        />
                      </Stack>
                      <Stack spacing={1}>
                        <Typography variant="p" sx={{ color: "gray" }}>
                          API Credential
                        </Typography>
                        <Card sx={{ p: 3, border: "0.5px solid lightgray" }}>
                          <Stack spacing={2}>
                            <Stack direction="row" spacing={1}>
                              <TextField
                                fullWidth
                                value={phoneNumber.username}
                                autoComplete="asdf"
                                label="Username"
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) =>
                                  setPhoneNumber({
                                    ...phoneNumber,
                                    username: e.target.value,
                                  })
                                }
                              />
                              <IconButton>
                                <Iconify
                                  icon="akar-icons:copy"
                                  width={22}
                                  height={22}
                                />
                              </IconButton>
                            </Stack>
                            <Stack direction="row" spacing={1}>
                              <TextField
                                fullWidth
                                value={phoneNumber.password}
                                autoComplete="zxcv"
                                type={showPassword ? "text" : "password"}
                                label="Password"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={handleShowPassword}
                                        edge="end"
                                      >
                                        <Iconify
                                          icon={
                                            showPassword
                                              ? "eva:eye-fill"
                                              : "eva:eye-off-fill"
                                          }
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) =>
                                  setPhoneNumber({
                                    ...phoneNumber,
                                    password: e.target.value,
                                  })
                                }
                              />
                              <IconButton>
                                <Iconify
                                  icon="akar-icons:copy"
                                  width={22}
                                  height={22}
                                />
                              </IconButton>
                            </Stack>
                          </Stack>
                        </Card>
                      </Stack>
                      <Stack xs={12} direction="row" justifyContent="flex-end">
                        <LoadingButton
                          size="large"
                          type="submit"
                          style={{
                            marginTop: 30,
                            marginRight: 10,
                          }}
                          variant="contained"
                          onClick={testConnection}
                          loading={isTestingConnection}
                        >
                          Test Connection
                        </LoadingButton>

                        <LoadingButton
                          size="large"
                          type="submit"
                          style={{
                            marginTop: 30,
                          }}
                          variant="contained"
                          onClick={onSubmit}
                          loading={isSubmitting}
                        >
                          <Iconify
                            icon="eva:save-outline"
                            width={22}
                            height={22}
                            sx={{ marginRight: 1 }}
                          />
                          Save
                        </LoadingButton>
                      </Stack>
                    </Stack>
                  ) : (
                    <Stack spacing={3}>
                      <Stack spacing={1}>
                        <Typography variant="h4" sx={{ color: "red" }}>
                          Docker is not on premise
                        </Typography>
                      </Stack>
                    </Stack>
                  )}
                </Card>
              )} */}
            </Grid>
            {dataIsFound && (
              <Grid item md={4} sm={12}>
                <Stack spacing={3}>
                  {/*<Card sx={{p: 4}}>*/}
                  {/*    <Stack spacing={2}>*/}
                  {/*        <Typography variant="h6">Action</Typography>*/}
                  {/*        <Divider/>*/}
                  {/*        <Typography variant="p">Request to upgrade your account into official*/}
                  {/*            account.</Typography>*/}
                  {/*        <Button*/}
                  {/*            fullWidth*/}
                  {/*            variant="contained"*/}
                  {/*        >*/}
                  {/*            Request official account*/}
                  {/*        </Button>*/}
                  {/*    </Stack>*/}
                  {/*</Card>*/}
                  {/* <Card sx={{ p: 4 }}>
                <Stack spacing={2}>
                  <Typography variant="h6">Credits</Typography>
                  <Divider />
                  <Stack direction="row" justifyContent="space-between">
                    <Stack direction="row" spacing={2}>
                      <Iconify icon="akar-icons:coin" width={22} height={22} />
                      <Typography variant="p">0</Typography>
                    </Stack>
                    <Iconify icon="akar-icons:clock" width={22} height={22} />
                  </Stack>
                  <Button
                    fullWidth
                    variant="outlined"
                  >
                    Manage credits
                  </Button>
                </Stack>
              </Card> */}
                  {/* {dockerStatus && (
                    <Card sx={{ p: 4 }}>
                      <Stack spacing={2}>
                        <Typography variant="h6">Docker</Typography>
                        <Divider />
                        <Stack spacing={0}>
                          <Typography variant="p" sx={{ color: "gray" }}>
                            Status
                          </Typography>
                          <Typography variant="p">
                            {dockerStatus?.gateway_status
                              ? dockerStatus.gateway_status
                              : "-"}
                          </Typography>
                        </Stack>
                        <Stack spacing={0}>
                          <Typography variant="p" sx={{ color: "gray" }}>
                            Docker type
                          </Typography>
                          <Typography variant="p">
                            {phoneNumber.type ? phoneNumber.type : "-"}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Card>
                  )} */}
                </Stack>
              </Grid>
            )}
          </Grid>
        ) : (
          <Stack sx={{ p: 4 }} direction="row" justifyContent="center">
            <CircularProgress />
          </Stack>
        )}
      </Container>
    </Page>
  );
}
